/*import { useMemo, useState } from "react";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import { Segmented } from "../../../components/ui-kit/controls";
import { Button } from "../../../components/ui-kit/Button";
import { EmptyState } from "../../../components/ui-kit/Card";
import { BarChartIcon, LayoutIcon, PlusIcon, RotateIcon, TableIcon } from "../../../components/ui-kit/icons";
import FilterBar from "./components/FilterBar/FilterBar";
import DataTable from "./components/DataTable/DataTable";
import WidgetCard from "./components/WidgetCard/WidgetCard";
import WidgetEditor from "./components/WidgetEditor/WidgetEditor";
import { FIELDS } from "../../../lib/report/fields";
import { applyFilterState, createFilterState } from "../../../lib/report/filter-state";
import { createWidget, defaultWidgets, nextWidgetId } from "./lib/report/widgets";
import { mockRows as rows } from "./lib/mockData";

import "./InformesPersonalizados.scss";

export default function InformesPersonalizados() {
    const [filterState, setFilterState] = useState(() => createFilterState());
    const [widgets, setWidgets] = useState(() => defaultWidgets());
    const [view, setView] = useState("dashboard");
    const [editing, setEditing] = useState(null);

    const filteredRows = useMemo(
        () => applyFilterState(rows, filterState, FIELDS),
        [rows, filterState]
    );

    const updateWidget = (next) => {
        setWidgets((prev) => {
            const exists = prev.some((widget) => widget.id === next.id);
            const clean = { ...next };
            delete clean.__isNew;
            return exists
                ? prev.map((widget) => (widget.id === next.id ? clean : widget))
                : [...prev, clean];
        });
        setEditing(null);
    };

    const moveWidget = (id, offset) => {
        setWidgets((prev) => {
            const index = prev.findIndex((widget) => widget.id === id);
            const target = index + offset;
            if (index < 0 || target < 0 || target >= prev.length) return prev;
            const copy = [...prev];
            const [item] = copy.splice(index, 1);
            copy.splice(target, 0, item);
            return copy;
        });
    };

    const viewOptions = [
        { value: "dashboard", label: "Cuadro de mando", icon: <LayoutIcon size={15} /> },
        { value: "table", label: "Detalle de datos", icon: <TableIcon size={15} /> },
    ];

    return (
        <PageLayout
            title="Informes"
            subtitle="Construye tu propio cuadro de mando y explora el detalle con filtros dinámicos."
            actions={
                <>
                    <Segmented value={view} onChange={setView} options={viewOptions} />

                    {view === "dashboard" && (
                        <>
                            <Button
                                variant="outline"
                                onClick={() => setWidgets(defaultWidgets())}
                            >
                                <RotateIcon size={15} />
                                Restablecer
                            </Button>
                            <Button
                                variant="primary"
                                onClick={() =>
                                    setEditing({ ...createWidget(), __isNew: true })
                                }
                            >
                                <PlusIcon size={16} />
                                Añadir gráfico
                            </Button>
                        </>
                    )}
                </>
            }
        >
            <FilterBar
                rows={rows}
                state={filterState}
                onChange={setFilterState}
                resultCount={filteredRows.length}
                totalCount={rows.length}
            />

            {view === "dashboard" ? (
                widgets.length === 0 ? (
                    <EmptyState
                        icon={<BarChartIcon size={26} />}
                        title="Tu informe está vacío"
                        description="Añade el primer gráfico eligiendo qué métrica quieres medir y cómo agruparla."
                        action={
                            <Button
                                variant="primary"
                                onClick={() =>
                                    setEditing({ ...createWidget(), __isNew: true })
                                }
                            >
                                <PlusIcon size={16} />
                                Añadir gráfico
                            </Button>
                        }
                    />
                ) : (
                    <div className="informes-personalizados-page__grid">
                        {widgets.map((widget, index) => (
                            <WidgetCard
                                key={widget.id}
                                widget={widget}
                                rows={filteredRows}
                                isFirst={index === 0}
                                isLast={index === widgets.length - 1}
                                onEdit={() => setEditing(widget)}
                                onMove={(offset) => moveWidget(widget.id, offset)}
                                onDuplicate={() =>
                                    setWidgets((prev) => {
                                        const copy = [...prev];
                                        copy.splice(index + 1, 0, {
                                            ...widget,
                                            id: nextWidgetId(),
                                            title: `${widget.title} (copia)`,
                                        });
                                        return copy;
                                    })
                                }
                                onRemove={() =>
                                    setWidgets((prev) =>
                                        prev.filter((item) => item.id !== widget.id)
                                    )
                                }
                            />
                        ))}
                    </div>
                )
            ) : (
                <DataTable rows={filteredRows} fields={FIELDS} />
            )}

            <WidgetEditor
                open={Boolean(editing)}
                widget={editing}
                rows={filteredRows}
                onClose={() => setEditing(null)}
                onSave={updateWidget}
            />
        </PageLayout>
    );
}*/
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import { ReportScreen } from "../../../components/reportNew/report-screenNew";
import { useState, useEffect } from "react";
import { useZone } from "../../../context/ZoneContext";
import { getApiInstance } from "../../../utils/api";
import { useGraficosUsuario } from "../../../hooks/useGraficosUsuario";
import { defaultWidgets } from "../../../lib/reportNew/widgetsNew";

export default function InformesPersonalizados() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();
    const { widgets, setWidgets, saveStatus } = useGraficosUsuario();

    useEffect(() => {
        const api = getApiInstance();
        api.get(`/api/ResiduosObra/GetResiduosObraInformesPers`)
            .then((response) => setData(response.data))
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    }, []);

    if (error) return <p>Error al cargar</p>;

    return (
        <PageLayout>
            <ReportScreen
                rows={data}
                loading={loading}
                widgets={widgets}
                setWidgets={setWidgets}
                onResetWidgets={() => setWidgets(defaultWidgets())}
                saveStatus={saveStatus}
            />
        </PageLayout>
    );
}
